import { call, takeLatest } from 'redux-saga/effects';

import { types as reservationDetailsType, actions as reservationDetailsActions } from 'ducks/salesOrderEnquiry/cdReservationDetails';

import { callApi } from 'sagas/utils';
import * as api from 'api/salesOrderEnquiry/cdReservationDetails';

function* getReservationDetails(action) {
  const { success, failure } = reservationDetailsActions.saga.fetchReservationDetails;
  yield callApi(
    call(api.getReservationDetails, action.data),
    success,
    failure
  )
}

export default function* rootLineDetailsSaga() {
  yield takeLatest(reservationDetailsType.fetchReservationDetails, getReservationDetails)
}